import type { BoxInfo } from '@lub0v/santa-utils';
import { useTranslation } from 'react-i18next';
import { formatBudgetAmount } from '@src/site/currency';

/** Shared guidance for writing wishes during setup and later edits. */
export function useWishHint(box: BoxInfo['box'], includeVisibility = true) {
  const { t, i18n } = useTranslation();
  const hint = t(includeVisibility ? 'game.cardCreate.wish.hint' : 'questions.letterGuidance');
  if (!box.useCashLimit || box.cashLimit <= 0) return hint;

  const budget = formatBudgetAmount(
    box.cashLimitMin,
    box.cashLimit,
    box.cashLimitCurrency,
    i18n.language,
  );
  const budgetHint = t(
    box.cashLimitMin > 0 ? 'game.cardCreate.wish.budgetHint' : 'game.cardCreate.wish.budgetMaxHint',
    { budget },
  );
  return `${budgetHint} ${hint}`;
}
